import { useMutation } from "@apollo/client/react";
import { CREATE_AML_RULE_REFERENCE_EXCLUSION } from "../../mutations/aml/createAmlRuleReferenceExclusion";

export const useCreateAmlRuleReferenceExclusion = ({
  onCompleted,
  onError,
}: any) => {
  const [createRiskScoreExclusion, { data, loading, error }] = useMutation(
    CREATE_AML_RULE_REFERENCE_EXCLUSION,
    {
      onCompleted: onCompleted,
      onError: onError,
      refetchQueries: [],
      awaitRefetchQueries: true,
    }
  );

  return { createRiskScoreExclusion, data, loading, error };
};
